import { render, staticRenderFns } from "./SupportMenuDialog.vue?vue&type=template&id=7331ff74&scoped=true&"
import script from "./SupportMenuDialog.vue?vue&type=script&lang=js&"
export * from "./SupportMenuDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupportMenuDialog.vue?vue&type=style&index=0&id=7331ff74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7331ff74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
